export default {    
    ADD_USER_LOGIN_ERROR: "setUserLoginError",
    ADD_USER_OTP: "setUserOtp",
    ADD_USER_MFA: "setUserMfa",
    ADD_USER_QRCODE: "setUserQrcode",
}